import React from "react";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../../../redux/brand";
import { actions as routerActions } from "../../../../../redux/router";
import styled from "styled-components";
import { t } from "../../../../core/translate";

const StyledHeaderLogo = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-start;
`;

const LogoImage = styled.img`
  height: 32px;
`;

const mapStateToProps = state => ({
  brandName: brandSelectors.getBrandValue(state, "name", "Bookshelf"),
  logo: brandSelectors.getBrandValue(state, "Graphics.logo", "logo_act.svg"),
  mobileLogo: brandSelectors.getBrandValue(
    state,
    "Graphics.logo",
    "logo_act.svg"
  )
});

const mapDispatchToProps = dispatch => ({
  push: dest => dispatch(routerActions.push(dest))
});

const LogoLink = ({ brandName, mobile = false, logo, mobileLogo, push }) => (
  <a
    href="/"
    onClick={e => {
      e.preventDefault();
      push("");
    }}
  >
    <LogoImage
      src={mobile ? mobileLogo : logo}
      alt={t("header.logo-alt", `Bookshelf Home`, {
        brandName
      })}
    />
  </a>
);

const WrappedLink = connect(
  mapStateToProps,
  mapDispatchToProps
)(LogoLink);

const BookshelfHeading = styled.h1`
  margin: 0;

  a {
    display: block;
  }
`;

export const MobileLogo = () => (
  <div>
    <BookshelfHeading>
      <WrappedLink mobile />
    </BookshelfHeading>
  </div>
);

export const Logo = () => (
  <StyledHeaderLogo>
    <WrappedLink />
  </StyledHeaderLogo>
);
